import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "position-delivery",
  "use": "position-delivery-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"position-delivery\"><path d=\"M5 10.2C5 5.803 8.321 3 12 3s7 2.803 7 7.2c0 1.331-.514 2.872-1.672 4.644-1.156 1.77-2.916 3.713-5.314 5.831l-.002.001a.02.02 0 0 1-.007.002.02.02 0 0 1-.007-.002h-.002c-2.403-2.12-4.166-4.063-5.323-5.832C5.514 13.072 5 11.53 5 10.2Zm4-.2c0 1.652 1.348 3 3 3s3-1.348 3-3-1.348-3-3-3-3 1.348-3 3Z\" fill=\"#fff\" stroke=\"#003595\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol